import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Card, Col, ListGroup, Row } from "react-bootstrap";
import PsContext from "../../context";
import ProgrammesLayout from "../innerPageLayout/programmesLayout";
import { ServiceUrl } from "../../utils/serviceUrl";
import {
  DB_POSTFIX,
  groupByMultiple,
  LOADER_LOGO,
  makeUrl,
  NO_IMAGE_LOGO_WIDE,
  upperCase,
} from "../../utils";
import { Link } from "react-router-dom";

const Programmes = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [courseType, setCourseType] = useState("");

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    setCourseType(props.match.params.coursetype);
    loadGroupData();
  }, [props.match.params, dataList]);

  const loadGroupData = () => {
    setLoader(true);
    let g = dataList.filter(
      (item) =>
        upperCase(item.academic_dept_type) ==
        upperCase(props.match.params.coursetype)
    );
    if (g && g.length > 0) {
      let m = groupByMultiple(g, function (obj) {
        return [obj.coursetype];
      });
      setDataView(m);
      setLoader(false);
    }
  };

  const loadData = () => {
    setLoader(true);
    axios.post(ServiceUrl.COURSES + "?sadb=" + DB_POSTFIX).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      }
      setLoader(false);
    });
  };

  const listCourses = (items) => {
    return items.map((item) => (
      <Col md={4} className="mb-3">
        <Link
          to={`/department/${item.academic_department}/${makeUrl(
            item.department_name
          )}`}
        >
          <Card>
            <Card.Img src={NO_IMAGE_LOGO_WIDE.default} className="bg-light" />
            <Card.Body className="fw-bold text-center text-dark">
              {item.department_name}
            </Card.Body>
          </Card>
        </Link>
      </Col>
    ));
  };

  return (
    <ProgrammesLayout courseType={props.match.params.coursetype}>
      {loader && (
        <center className="py-5">
          {" "}
          <img src={LOADER_LOGO.default} />{" "}
        </center>
      )}
      <div className="my-4"></div>
      {dataView.map((item) => (
        <Row>{listCourses(item)}</Row>
      ))}
    </ProgrammesLayout>
  );
};

export default Programmes;
